var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8656 1.56097C18.0317 1.56319 17.3512 2.24692 17.3534 3.08083L17.3566 4.35027L1.89282 4.38975L1.96035 30.4193L34.1549 31.681L35.0001 30.3337L34.9385 6.2466L34.9338 4.30476L34.9305 3.03532C34.9284 2.2014 34.2446 1.52085 33.4108 1.52308L18.8656 1.56097Z",
    fill: "#C6A37D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1.55665 18.9494C1.52712 19.1534 1.66799 19.3419 1.87194 19.3714L28.2204 23.1994C28.4244 23.2289 28.6129 23.0881 28.6424 22.8841C28.6424 22.8841 29.9511 4.55213 29.7472 4.52271L4.58261 0.710608C4.37961 0.680761 1.55665 18.9494 1.55665 18.9494Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41015 1.08606L0.700195 19.7468L27.7862 23.6802L30.4961 5.0196L3.41015 1.08606Z",
    fill: "#BCEDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M28.1221 22.6779L28.2154 4.41816L1.86661 3.46338L1.55322 22.3171L28.1221 22.6779Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.313921 4.13269L0 22.9866L27.3666 23.4423L27.6806 4.58833L0.313921 4.13269Z",
    fill: "#E6FFFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M18.5253 2.31841C17.6914 2.32064 17.0108 3.00436 17.013 3.83827L17.0162 5.10772L1.55249 5.1472L1.6197 31.1759L34.1547 31.6782L34.5981 7.00394L34.5934 5.06221L34.5902 3.79276C34.588 2.95885 33.9042 2.2783 33.0703 2.28052L18.5253 2.31841Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0213 2.90839C17.1874 2.91061 16.5068 3.59433 16.509 4.42825L16.5123 5.69769L1.04883 5.73801L1.11608 31.7667L34.1561 31.682L34.0944 7.59487L34.0898 5.65303L34.0866 4.38358C34.0844 3.54967 33.4007 2.86923 32.5667 2.87134L18.0213 2.90839Z",
    fill: "#E9C092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M24.6645 5.24349L34.1574 5.23947L24.6633 4.79663L24.6645 5.24349Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M34.1561 31.6819L1.04883 5.73792L1.11608 31.7666L34.1561 31.6819Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.b23d9f79e8c5acc80f158ed251086f43.svg";
export { ForwardRef as ReactComponent };